import { useMemo } from 'react';
import QrRef from "../../QrRef";
import { useWindowSize } from '../../../../utils/hooks/useWindowSize';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../utils/Auth';
import { useUserPermissions } from '../../../../utils/hooks/useUserPermissions';
import styles from './View.module.css';

export default function View() {

    const { qr_data } = useAuth();
    const { canEditQR } = useUserPermissions();
    const navigate = useNavigate();
    const { width } = useWindowSize();
    const size = useMemo(() => {
        if (width <= 500) {
            return 265;
        } else if (width <= 768) {
            return 300;
        } else if (width <= 992) {
            return 250;
        } else {
            return 300;
        }
    },[width]);
    const isLinked = useMemo(() => qr_data?.data?.linked_qr, [qr_data?.data?.linked_qr]);

    const handleEdit = () => navigate(`/collection/${qr_data?.id}/edit?tab=configure`);
    const handleDesign = () => navigate(`/collection/${qr_data?.id}/design`);
    const handleGoToParent = () => navigate(`/collection/${qr_data?.data?.linked_qr}/details`);

    return (
        <div className={styles.container}>
            <div className={styles.left}>
                <h5 className={styles.header}>View</h5>
                <div className={styles.words}>
                    This is a quick look at your QR code, a perfect snapshot of your current design! Ready to make it even more amazing? Click the "Configure QR" to update the details of your QR, or click "Design QR" to update how your QR looks.
                </div>
                {isLinked ?
                    <button className={styles.editBtn} onClick={handleGoToParent}>Go To Parent QR</button>
                :
                    <button
                        className={styles.editBtn}
                        onClick={handleEdit}
                        disabled={isLinked || !canEditQR}
                        title={!canEditQR ? 'You do not have permission to edit QR codes.' : undefined}
                    >
                        Configure QR
                    </button>
                }
                <button
                    className={styles.editBtn}
                    onClick={handleDesign}
                    disabled={!canEditQR}
                    title={!canEditQR ? 'You do not have permission to edit QR codes.' : undefined}
                >
                    Design QR
                </button>
            </div>
            <div className={styles.right}>
                <div className={styles.qrWrap}>
                    <QrRef size={size} />
                </div>
            </div>
            <div className={styles.blue} />
        </div>
    );
};
